<template>
  <v-col cols="4">
    <v-card class="fill-height">
      <v-container>
        <v-row dense align="start">
          <v-col class="font-weight-bold"> {{ therapy.medicine.name }} </v-col>

          <v-col cols="auto">
            <authorization
              permissionKey="attendance_therapy"
              can="delete"
              v-slot:default="{ authorization }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="editItem"
                    v-if="authorization && lodash.isEmpty(currentApplications)"
                  >
                    <v-icon>eva-edit-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Editar
                </span>
              </v-tooltip>
            </authorization>
          </v-col>
          
          <v-col cols="auto">
            <authorization
              permissionKey="attendance_therapy"
              can="delete"
              v-slot:default="{ authorization }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    :attrs="attrs"
                    v-on="on"
                    @click="deleteSurgeryTherapy"
                    v-if="authorization && lodash.isEmpty(currentApplications) && allowDelete"
                  >
                    <v-icon>eva-trash-outline</v-icon>
                  </v-btn>
                </template>

                <span>
                  Excluir
                </span>
              </v-tooltip>
            </authorization>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col class="font-weight-bold">
            {{ applicationRouteAction  }}
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <authorization
          permissionKey="attendance_therapy"
          can="action"
          v-slot:default="{ authorization }"
        >
          <v-row dense>
            <v-col cols="6">
              <v-row dense>
                <v-col>
                  {{ therapy.applicationRoute.name }}
                </v-col>
              </v-row>

              <v-row dense v-if="therapy.dilation">
                <v-col>
                  {{ therapy.refract ? "Refratar" : "Não Refratar" }}
                </v-col>
              </v-row>

              <v-row dense>
                <v-col v-if="globalBatch === ''">
                  <v-text-field
                    v-model="batch"
                    label="Lote"
                    outlined
                    dense
                    :hide-details="errors.batch === undefined"
                    :error-messages="errors.batch"
                    :disabled="!authorization || !allowEdit"
                  />
                </v-col>
                <v-col v-else> Lote: {{ globalBatch }} </v-col>
              </v-row>
            </v-col>

            <v-col cols="6">
              <v-row dense align="center">
                <v-col cols="4" v-for="application in applications" :key="application.id">
                  <v-row
                    dense
                    justify="center"
                    :style="{ color: $Color().colorFor(application.color) }"
                  >
                    <v-col cols="auto">
                      <v-btn
                        small
                        icon
                        @click="applyTherapy"
                        :disabled="!authorization || !allowEdit"
                      >
                        <v-icon
                          v-if="application.id"
                          large
                          :color="$Color().colorFor(application.color)"
                        >
                          {{ applicationRouteIconFilled }}
                        </v-icon>

                        <v-icon v-else large :color="$Color().colorFor(application.color)">
                          {{ applicationRouteIcon }}
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row
                    dense
                    justify="center"
                    :style="{ color: $Color().colorFor(application.color) }"
                  >
                    <v-col cols="auto">
                      {{
                        $moment(application.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                          | moment("HH:mm")
                      }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        
        </authorization>
        <AttendanceTherapyForm
        :attendance="attendance"
        :showAttendanceTherapyForm="showAttendanceTherapyForm"
        :toggleShow="() => (showAttendanceTherapyForm = !showAttendanceTherapyForm)"
        :therapy="this.therapy"
        :editView="showAttendanceTherapyForm"

      />
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import AttendanceTherapyForm from "@/components/attendance_therapy/form/index.vue";

  export default {
    name: "TherapyListItem",
    props: {
      attendance: Object,
      therapy: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      AttendanceTherapyForm
    },
    data() {
      return {
        errors: {},
        batch: "",
        timeNow: new Date(),
        setInterval: null,
        showAttendanceTherapyForm: false,
      };
    },
    beforeDestroy() {
      clearInterval(this.setInterval);
    },
    created() {
      this.setInterval = setInterval(
        function() {
          this.timeNow = new Date();
        }.bind(this),
        1000
      );
    },
    computed: {
      applications() {
        return this.currentApplications.concat(this.missingApplications);
      },
      currentApplications() {
        if (this.therapy) {
          const applications = this.lodash.map(this.therapy.applications, function(o) {
            return Object.assign(o, { color: { color: "green", saturation: 0 } });
          });

          return this.lodash.orderBy(applications, ["createdAt"], ["asc"]);
        }

        return [];
      },
      missingApplications() {
        const applications = [];
        let lastApplication = this.lodash.last(this.currentApplications);
        let lastCreatedAt = this.$moment().subtract(this.therapy.interval, "m");

        if (lastApplication !== undefined) lastCreatedAt = lastApplication.createdAt;

        let numberOfApplications = this.therapy.numberOfApplications;
        let missingApplications = numberOfApplications - this.currentApplications.length;

        for (let index = 0; index < missingApplications; index++) {
          lastCreatedAt = this.$moment(lastCreatedAt).add(this.therapy.interval, "m");
          let color = { color: "secondary2", saturation: -10 };

          if (this.timeNow > lastCreatedAt) {
            color = { color: "error", saturation: 0 };
          }

          applications.push({ createdAt: lastCreatedAt, color: color });
        }

        return applications;
      },
      globalBatch() {
        if (this.therapy.applications.length > 0) {
          return this.therapy.applications[0].batch;
        }

        return "";
      },
      applicationRouteIcon() {
        switch (this.therapy.applicationRoute.name) {
          case "uso ocular":
            return "eva-droplet-outline";
          case "uso oral":
            return "ri-capsule-fill";
          case "uso externo":
            return "ri-medicine-bottle-line";
          case "uso intramuscular":
            return "ri-syringe-line";
          case "endovenoso":
            return "ri-syringe-line";
          default:
            return "ri-capsule-fill";
        }
      },
      applicationRouteIconFilled() {
        switch (this.therapy.applicationRoute.name) {
          case "uso ocular":
            return "eva-droplet";
          case "uso oral":
            return "ri-capsule-fill";
          case "uso externo":
            return "ri-medicine-bottle-fill";
          case "uso intramuscular":
            return "ri-syringe-fill";
          case "endovenoso":
            return "ri-syringe-fill";
          default:
            return "ri-capsule-fill";
        }
      },
      applicationRouteAction() {
        switch (this.therapy.applicationRoute.name) {
          case "uso ocular":
            return "Aplicar " + this. therapy.applicationSite.name;
          case "uso oral":
            return "Tomar " + this. therapy.applicationSite.name;
          case "uso externo":
            return "aplicar " + this. therapy.applicationSite.name;
          case "uso intramuscular":
            return "injetar " + this. therapy.applicationSite.name;
          case "endovenoso":
            return "injetar " + this. therapy.applicationSite.name;
          default:
            return "";
        }
      },
    },
    methods: {
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        if (!this.batch) {
          this.errors.batch = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      applyTherapy() {
        if (this.globalBatch !== "") {
          this.batch = this.globalBatch;
        }

        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/attendance/add_attendance_therapy_application.gql"),
          variables: {
            attendanceTherapyId: this.therapy.id,
            batch: this.batch,
          },
        });
      },
      editItem() {
        this.showAttendanceTherapyForm = true
      },
      deleteSurgeryTherapy() {
        return this.apolloMutate({
          mutation: require("@/graphql/attendance/delete_attendance_therapy.gql"),
          variables: {
            attendanceTherapyId: this.therapy.id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
